import Vue from 'vue'
import { camelizeKeys, decamelizeKeys } from 'xcase'
import CurrentUser from '@/models/currentUser'

export const state = {
  user: null,
  loaded: false,
}

export const getters = {}

export const mutations = {
  SET(state, user) {
    state.loaded = false
    state.user = new CurrentUser(user)
    state.loaded = true
    Vue.auth.user(state.user)
  },
}

export const actions = {
  async update({ commit }, data) {
    try {
      const response = await Vue.axios.put('/profile', { profile: decamelizeKeys(data) })

      commit('SET', response.data)
      commit('users/UPDATE', response.data, { root: true })

      return response.data
    } catch (error) {
      if (error.response.status == 500) {
        Vue.notyf.error('Something went wrong. Please try again.')
      }

      return error.response
    }
  },

  async deleteAccount({ commit }) {
    try {
      await Vue.axios.delete('/profile')

      // Clear user data and logout
      commit('SET', null)
      Vue.auth.logout()

      return true
    } catch (error) {
      Vue.notyf.error('Failed to delete account. Please try again.')
      console.log(error)
      throw error
    }
  },

  async blockUser({ commit }, id) {
    try {
      const response = await Vue.axios.post(`/users/${id}/blocks`)
      commit('users/REMOVE', id, { root: true })

      return response.data
    } catch (error) {
      Vue.notyf.error('Something went wrong. Please try again.')
      console.log(error)
    }
  },

  async fetchBlockUsers({ commit }) {
    try {
      const response = await Vue.axios.get('/users/blocks')
      return response.data
    } catch (error) {
      Vue.notyf.error('Something went wrong. Please try again.')
      console.log(error)
    }
  },

  async unblock({ commit }, id) {
    try {
      const response = await Vue.axios.delete(`/blocks/${id}`)
      return response
    } catch (error) {
      Vue.notyf.error('Something went wrong. Please try again.')
      console.log(error)
    }
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
